

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.kDnf5yng.js","_app/immutable/chunks/disclose-version.DJVJNQBy.js","_app/immutable/chunks/runtime.Bk3K0l7O.js","_app/immutable/chunks/legacy.D3eNFHPr.js","_app/immutable/chunks/slot.CZkCa1q3.js","_app/immutable/chunks/lifecycle.JwKvXvYo.js","_app/immutable/chunks/entry.D8dy3a0s.js","_app/immutable/chunks/index-client.BvveTgYa.js"];
export const stylesheets = [];
export const fonts = [];
